import 'css-chunksrc/client/scenes/projectPopup/projectPortfoliosList/projectPortfolioTag/styles.scss';export default {
  "tag": "_tag_1kyeg_1",
  "icon": "_icon_1kyeg_11",
  "name": "_name_1kyeg_19",
  "removeIconBox": "_removeIconBox_1kyeg_27",
  "removeIcon": "_removeIcon_1kyeg_27"
};